var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8693 0.843287C18.5091 0.460657 18.0535 0.193449 17.5552 0.0726072C17.057 -0.0482342 16.5364 -0.0177653 16.0539 0.160485L2.25612 5.19284C1.53708 5.45502 0.946815 5.93223 0.546153 6.57542C0.179227 7.17538 -0.0106801 7.87664 0.000463773 8.59046C0.0116076 9.30427 0.223302 9.99856 0.608757 10.5855C1.03088 11.2136 1.63545 11.6719 2.36165 11.9077L5.42386 12.9055C5.62395 12.9712 5.83729 12.9778 6.04069 12.9246C6.24408 12.8713 6.42977 12.7604 6.57755 12.6037L9.03518 10.0121C9.18627 9.85273 9.3912 9.76322 9.60487 9.76322C9.81855 9.76322 10.0235 9.85273 10.1746 10.0121C10.3257 10.1714 10.4105 10.3875 10.4105 10.6128C10.4105 10.8381 10.3257 11.0542 10.1746 11.2136L7.71693 13.8052C7.56835 13.961 7.46311 14.1568 7.41265 14.3713C7.3622 14.5858 7.36846 14.8108 7.43074 15.0218L8.37695 18.2509C8.60053 19.0167 9.03518 19.6543 9.63081 20.0994C10.186 20.5093 10.8456 20.7328 11.5232 20.7407H11.5805C12.2383 20.7431 12.8825 20.5425 13.4335 20.1635C14.0435 19.741 14.496 19.1186 14.7446 18.3603L19.5168 3.81027C19.6855 3.3017 19.7142 2.75317 19.5996 2.22812C19.485 1.70307 19.2318 1.22295 18.8693 0.843287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.3be2fef9e1d7e5c7d06f08897acfea6c.svg";
export { ForwardRef as ReactComponent };